export const CURRENT_PRIVILEGE = 'CURRENT_PRIVILEGE'

export function assignCurrentPrivilege(data) {
    return {type: CURRENT_PRIVILEGE, data}
}